'use strict';

const { LOCALES } = require('../../constants');
const _ = require('lodash');

/**
 * 語系順序：user > locale.js第一個
 * @returns {number}
 */
const i18nIdx = user => {
	if (user) {
		const idx = _.indexOf(_.keys(LOCALES), user.locale);
		return idx < 0 ? 0 : idx;
	}
	if (typeof window !== 'undefined') {
		// 暫解 (因為這支檔案後端也有用，沒辦法 import Cache.js)
		const _context = key => {
			if (window.context) return `${window.context}:${key}`;
			return key;
		};
		const idx = Number(localStorage.getItem(_context('localeIdx')));
		return 0 <= idx && idx < _.keys(LOCALES).length ? idx : 0;
	}
	return 0;
};

/**
 * 語系順序：user > zh_TW
 * <p><b>僅供 I18nText/listI18n/TD.i18n(renderGridHeader:TH.i18nSortable), 其他請用 adapt</b></p>
 * @param {object} obj
 * @param {User} [user]
 * @returns {string|*}
 */
const i18n = (obj, user) => {
	try {
		if (!_.isPlainObject(obj)) return obj;
		let localeKey = _.keys(LOCALES)[0];
		if (user && user.locale) localeKey = user.locale;
		return obj[localeKey];
	}
	catch (err) {
		return '';
	}
};

/**
 * 語系順序：<br/>
 * <ul>
 * <li>obj 為 array 時：user > locale.js第一個</li>
 * <li>obj 為 object 時：user > 登入公司 > locale.js第一個</li>
 * </ul>
 * @param {object|array} obj
 * @param {User} [user]
 * @returns {string|*}
 */
const adapt = (obj, user) => {
	if (_.isArray(obj)) return obj[LocaleUtils.i18nIdx()];
	if (!_.isPlainObject(obj)) return obj;
	let clone = _.clone(obj);
	if (user) {
		let localeKey = user.locale;
		if (obj.hasOwnProperty(localeKey) && !_.isNil(obj[localeKey]) && obj[localeKey] !== '') {
			return obj[localeKey];
		} else clone = _.omit(clone, localeKey);
		if (user.companies && user.bid) {
			let c = _.find(user.companies, { id: user.bid });
			if (c) {
				localeKey = c.locale;
				if (obj.hasOwnProperty(localeKey) && !_.isEmpty(obj[localeKey])) return obj[localeKey];
				else clone = _.omit(clone, localeKey);
			}
		}
	}
	if (typeof window !== 'undefined') {
		let localeKey = Object.keys(LOCALES)[LocaleUtils.i18nIdx()];
		if (obj.hasOwnProperty(localeKey) && !_.isEmpty(obj[localeKey])) return obj[localeKey];
		else clone = _.omit(clone, localeKey);
	}
	let values = _.values(_.pickBy(clone));
	return (values && values.length > 0) ? values[0] : '';
};

/**
 * 回傳現有語系
 * @returns {array}
 */
const allI18n = () => {
	return LOCALES ? Object.keys(LOCALES) : [];
};

module.exports = {
	i18nIdx, i18n, adapt, allI18n
};
